<template>
  <div>
    <div class="top">
      <h1 v-scroll-reveal="{ distance: '1px' }">We're hiring</h1>
      <h2 v-scroll-reveal="{ delay: 200 }">
        We're constantly looking for the sharpest minds in the industry. If
        you're one of them, please drop us an email at
        <a href="mailto:work@madepeople.se" target="_blank"
          >info@madepeople.se</a
        >
        or apply to one of the open positions below.
      </h2>
    </div>
    <div class="content">
      <Block
        position="Fullstack Developer"
        copy="If you're a developer who is always curious about the technology of tomorrow, this is the place for you."
        url="https://careers.madepeople.se/jobs/1879088-fullstack-developer"
        v-scroll-reveal="{ delay: 0 }"
      />
    </div>
    <img src="static/images/joinbw.jpg" alt="Frejgatan Office" />
    <Footer />
  </div>
</template>
<script>
import Block from "@/components/joinus/Block.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "join-us",
  components: {
    Block,
    Footer
  },
  beforeCreate: function() {
    document.body.classList.remove("dark");
    document.body.classList.remove("invert");
  },
  methods: {
    invertColor() {
      if (
        window.scrollY >
        document.body.clientHeight - window.innerHeight - 500
      )
        document.body.classList.add("invert");
      else document.body.classList.remove("invert");
    }
  },
  created() {
    window.addEventListener("scroll", this.invertColor);
  },
  destroyed() {
    window.removeEventListener("scroll", this.invertColor);
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/typography.scss";
.top {
  padding: 20vh 5.3% 5vh 5.3%;
  display: flex;
  align-items: left;
  flex-direction: column;
  justify-content: left;
  h1 {
    @include headline-large;
    color: $pink;
    animation: blink 1s steps(5, start) infinite;
    margin-bottom: 1em;
    //display:none;
  }
  h2 {
    width: 50%;
    padding-right: 3vw;
    @include headline-small;
    font-weight: 300;
    a {
      //color:#CB7CFF;
      //text-decoration: underline;
    }
  }
}
img {
  max-width: 100%;
  display: block;
}
.content {
  padding: 20vh 5.3vw;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: left;
}
@keyframes blink {
  to {
    visibility: hidden;
  }
}
@media (max-width: $tablet) {
  .top {
    padding: 150px 50px 0 50px;
    h2 {
      width: 100%;
      padding-right: 0;
    }
  }
  .content {
    padding: 100px 50px;
    flex-wrap: wrap;
  }
  img {
    object-fit: cover;
    width: 100%;
    height: 500px;
    object-position: 0 0;
  }
}
@media (max-width: $mobile) {
  .top {
    padding: 100px 30px;
  }
  .content {
    padding: 0px 30px;
    flex-direction: column;
  }
  img {
    height: 250px;
  }
}
</style>
